import { render, staticRenderFns } from "./InvestmentFundCard.vue?vue&type=template&id=e2645948&scoped=true"
import script from "./InvestmentFundCard.vue?vue&type=script&lang=js"
export * from "./InvestmentFundCard.vue?vue&type=script&lang=js"
import style0 from "./InvestmentFundCard.vue?vue&type=style&index=0&id=e2645948&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2645948",
  null
  
)

export default component.exports